<template>
  <div class="search-bar">
    <auto-complete
      icon="ios-search"
      clearable
      v-model="searchValue"
      @on-change="handleSearch"
      placeholder="Поиск по системе"
      :transfer="false">
        <div class="search-bar__results">
          <div class="search-bar__results-header ms-help" v-if="!isFirstTime">
            <span class="search-bar__results-header-title">
              Результаты поиска ({{ data.length }}):
            </span>
            <spin v-if="loading" />
          </div>
          <search-results-list v-if="data.length" :results="data" />
          <div class="ms-text ms-nodata" v-else>
            {{ isFirstTime ? 'Начните поиск по системе' : 'Совпадений не найдено' }}
          </div>
        </div>
      </auto-complete>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import SearchResultsList from './search-results-list'

export default {
  components: {
    SearchResultsList
  },
  data () {
    return {
      isFirstTime: true,
      loading: false,
      data: [],
      searchValue: ''
    }
  },
  methods: {
    handleSearch: debounce(async function (value) {
      if (!value) return
      this.isFirstTime = false

      try {
        this.loading = true
        const url = `page/search?string=${value}`
        this.data = await this.$store.dispatch('GET_REQUEST', { url })

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }, 200)
  }
}
</script>

<style lang="less">
  .search-bar {
    width: 100%;
    line-height: 40px;
    display: flex;
    align-items: center;

    .ivu-auto-complete {
      // width: 100% !important;
    }

    .ivu-select-dropdown {
      z-index: 1000;
      max-width: 480px;
    }

    &__results {
      padding: 4px 8px;
    }

    &__results-header {
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
</style>
